module.exports = __webpack_public_path__ + "img/qiu2.3ac96c88.png";